import React from "react";
import { Modal } from "../..";
import { FaPhoneAlt, FaPhoneSlash } from "react-icons/fa";

interface IncomingCallModalProps {
  caller: string;
  onAccept: () => void;
  onReject: () => void;
  isAccepting?: boolean;
  isRejecting?: boolean;
}

export const IncomingCallModal: React.FC<IncomingCallModalProps> = ({
  caller,
  onAccept,
  onReject,
  isAccepting = false,
  isRejecting = false
}) => {
  return (
    <Modal 
      isOpen 
      title={() => <h2 className="title is-5">Incoming WhatsApp Call</h2>}
      onClose={undefined}
    >
      <div className="has-text-centered p-4">
        <div className="is-flex is-justify-content-center mb-4">
          <div
            className="is-flex is-justify-content-center is-align-items-center has-background-success-light"
            style={{ width: "80px", height: "80px", borderRadius: "50%" }}
          >
            <FaPhoneAlt className="has-text-success" size={40} />
          </div>
        </div>

        <p className="is-size-4 mb-2">WhatsApp Call</p>
        <p className="is-size-5 mb-5">
          From <strong>{caller}</strong>
        </p>

        <div className="is-flex is-justify-content-center" style={{ gap: '2rem' }}>
          <button
            className={`button is-danger is-rounded ${isRejecting ? 'is-loading' : ''}`}
            onClick={onReject}
            disabled={isAccepting || isRejecting}
            style={{ width: '60px', height: '60px' }}
          >
            {!isRejecting && <FaPhoneSlash size={24} />}
          </button>
          <button
            className={`button is-success is-rounded ${isAccepting ? 'is-loading' : ''}`}
            onClick={onAccept}
            disabled={isAccepting || isRejecting}
            style={{ width: '60px', height: '60px' }}
          >
            {!isAccepting && <FaPhoneAlt size={24} />}
          </button>
        </div>
      </div>
    </Modal>
  );
};